module.exports = __webpack_public_path__ + "img/Objetivo 2.f71b536b.png";